//
import { mapActions } from 'vuex'
import { RBtn, RTable } from '@/components/reusable_components/next'

//
import PurchaseOrderModel from '@/models/Purchase/PchPurchaseOrderToList'
import filters from './filters'
import headers from './headers'

//
export default {
    name: 'purchase-order-list',
    components: {
        RBtn,  
        RTable,
    },
    computed: {
        /**
         *
         */
        tableProps() {
            return {
                service: PurchaseOrderModel,
                filters,
                headers,
            }
        },
    },
    methods: {
        //
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        /**
         *
         */
        submitReception(event) {
            this.$router.push({
                name: 'purchase-order-reception',
                params: { id: event.item.id },
            })
        },

        /**
         *
         */
        submitUpdate(event) {
            this.$router.push({
                name: 'purchase-order-update',
                params: { id: event.item.id },
            })
        },
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_ALL_PURCHASE_ORDER')) ctx.$router.push('/')
        })
    },
    beforeMount() {
        this.setTitleTopBar('Ordenes de compra')
    },
}
